const HANDLE_LOGIN_REQUEST = 'user/HANDLE_LOGIN_REQUEST';
const HANDLE_LOGIN_FAILURE = 'user/HANDLE_LOGIN_FAILURE';
const HANDLE_LOGIN_SUCCESS = 'user/HANDLE_LOGIN_SUCCESS';

const HANDLE_REFRESH_TOKEN_REQUEST = 'user/HANDLE_REFRESH_TOKEN_REQUEST';
const HANDLE_REFRESH_TOKEN_FAILURE = 'user/HANDLE_REFRESH_TOKEN_FAILURE';
const HANDLE_REFRESH_TOKEN_SUCCESS = 'user/HANDLE_REFRESH_TOKEN_SUCCESS';

const HANDLE_LOGOUT = 'user/HANDLE_LOGOUT';

const LOAD_USER_FROM_TOKEN = 'user/LOAD_USER_FROM_TOKEN';

const FORGOT_PASSWORD_REQUEST = 'user/FORGOT_PASSWORD_REQUEST';
const FORGOT_PASSWORD_FAILURE = 'user/FORGOT_PASSWORD_FAILURE';
const FORGOT_PASSWORD_SUCCESS = 'user/FORGOT_PASSWORD_SUCCESS';

const RECOVER_PASSWORD_REQUEST = 'user/RECOVER_PASSWORD_REQUEST';
const RECOVER_PASSWORD_FAILURE = 'user/RECOVER_PASSWORD_FAILURE';
const RECOVER_PASSWORD_SUCCESS = 'user/RECOVER_PASSWORD_SUCCESS';

export default {
  HANDLE_LOGIN_REQUEST,
  HANDLE_LOGIN_FAILURE,
  HANDLE_LOGIN_SUCCESS,

  HANDLE_REFRESH_TOKEN_REQUEST,
  HANDLE_REFRESH_TOKEN_FAILURE,
  HANDLE_REFRESH_TOKEN_SUCCESS,

  HANDLE_LOGOUT,

  LOAD_USER_FROM_TOKEN,

  FORGOT_PASSWORD_REQUEST,
  FORGOT_PASSWORD_FAILURE,
  FORGOT_PASSWORD_SUCCESS,

  RECOVER_PASSWORD_REQUEST,
  RECOVER_PASSWORD_FAILURE,
  RECOVER_PASSWORD_SUCCESS,
};
